import { useCallback } from 'react';
import { copyToClipboard } from '@blink/components/src/utils';

import { toast } from './useToast';

export const useCopyToClipboard = (text: string) => {
    const handleCopy = useCallback(
        (e: React.MouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            copyToClipboard(text);
            toast({
                title: 'Copied to clipboard!',
                variant: 'success',
            });
        },
        [text],
    );

    return handleCopy;
};
